import { useProfile } from "../context/ProfileContext";


const useHighlightEhrMessage = () => {
  const { profile } = useProfile();
  return !profile?.ehr_type?.trim() || !profile?.ehr_username?.trim();
};

export default useHighlightEhrMessage;
